__turbopack_context__.v({
  "accordion": "_3uouPq_accordion",
  "bottomBorder": "_3uouPq_bottomBorder",
  "content": "_3uouPq_content",
  "header": "_3uouPq_header",
});
